/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { ProgressCircle } from '../UNSAFE_ProgressCircle';
import { withThemeProps } from '#hoc/UNSAFE_withThemeProps';
import { View } from '#UNSAFE_View';
import { useColorScheme } from '#hooks/UNSAFE_useColorScheme';

export type Props = {
  /**
   * This indicates that the Loading indicator should be rendered in contrast.
   */
  isLoadingContrast?: boolean;
};
/**
 * AdjustedProgressCircle provides a Progress Circle that can be rendered on a dark background as needed.
 * @param param0
 * @returns
 */
export function AdjustedProgressCircle({ isLoadingContrast = false }: Props) {
  const ViewWithThemeProps = withThemeProps(View);

  const currentColorScheme = useColorScheme();
  const newColorScheme = !currentColorScheme || currentColorScheme === 'light' ? 'dark' : 'light';

  return isLoadingContrast ? (
    <ViewWithThemeProps colorScheme={newColorScheme} height="100%" width="100%">
      <ProgressCircle size="sm" value="indeterminate" />
    </ViewWithThemeProps>
  ) : (
    <ProgressCircle size="sm" value="indeterminate" />
  );
}

AdjustedProgressCircle.displayName = 'AdjustedProgressCircle';
